import { Organization } from "@/model/data/organizations/Organization";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetOrganizationsResData } from "./GetOrganizationsCommand";

const ENDPOINT = "/organizations";

export class AddOrganizationCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    params: Organization = null;

    constructor(organization: Organization) {
        super();
        this.params = organization;
    }

    public async execute(): Promise<GetOrganizationsResData> {
        var res = await this.executeCommand(this.params);
        return new GetOrganizationsResData(res);
    }
}
